import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    if (this.getCookie('cookie_consent') !== null) {
      this.close()
    }
  }

  accept() {
    this.submit('/cookie_consents/accept')
  }

  decline() {
    this.submit('/cookie_consents/decline')
  }

  openModalPreferences(e) {
    this.close()
    const cookiePreferencesModal = document.getElementById('cookiePreferences')
    if (cookiePreferencesModal && cookiePreferencesModal.modal) {
      cookiePreferencesModal.modal.open(e, e.currentTarget.dataset.param)
    }
  }

  // setCookie(name, value, days) {
  //   var expires = ""
  //   if (days) {
  //     var date = new Date()
  //     date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
  //     expires = "; expires=" + date.toUTCString()
  //   }
  //   document.cookie = name + "=" + (value || "") + expires + "; path=/"
  // }

  getCookie(name) {
    var nameEQ = name + "="
    var ca = document.cookie.split(';')
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i]
      while (c.charAt(0) == ' ') c = c.substring(1, c.length)
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
    }
    return null
  }

  // deleteCookie(name) {
  //   document.cookie = name + "=; Max-Age=-99999999;"
  // }

  getCSRFToken() {
    return document.querySelector('meta[name="csrf-token"]').getAttribute('content')
  }

  close() {
    this.element.style.display = 'none';
  }

  submit(url) {
    fetch(url, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': this.getCSRFToken(),
      } 
    }).then(() => this.close())
  }
}
